module.exports = __webpack_public_path__ + "static/media/Registry_Sparkle_Left.4832984d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/registry/Registry_Sparkle_Left.svg
// module id = 2595
// module chunks = 70